var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5318 47.7039L41.7051 30.1572L30.3984 30.7492",
    stroke: "#98BCDE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7025 55.2236L19.7465 56.6636C19.2129 56.6864 18.6801 56.6011 18.1803 56.4127C17.6805 56.2242 17.224 55.9367 16.8382 55.5672C16.4524 55.1977 16.1454 54.7541 15.9355 54.2629C15.7257 53.7717 15.6174 53.2431 15.6172 52.7089V19.0956C15.6176 18.0761 16.0111 17.0959 16.716 16.3593C17.4208 15.6227 18.3827 15.1862 19.4012 15.1409L54.0092 13.6303C54.3295 13.616 54.6494 13.6669 54.9495 13.7797C55.2496 13.8925 55.5238 14.0649 55.7554 14.2866C55.9871 14.5083 56.1714 14.7746 56.2973 15.0694C56.4232 15.3643 56.488 15.6816 56.4879 16.0023V51.2703C56.4871 52.2898 56.0932 53.2698 55.3881 54.0062C54.683 54.7426 53.7211 55.1786 52.7025 55.2236Z",
    stroke: "#98BCDE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6172 29.4898V25.5298C15.6172 24.2578 16.6172 23.2125 17.8879 23.1565L54.0092 21.5805C54.3295 21.5662 54.6494 21.6171 54.9495 21.7299C55.2496 21.8427 55.5238 22.0151 55.7554 22.2368C55.9871 22.4584 56.1714 22.7248 56.2973 23.0196C56.4232 23.3145 56.488 23.6318 56.4879 23.9525V29.0231",
    stroke: "#98BCDE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3811 13.664V10.4987C49.3811 10.0714 49.2946 9.64854 49.1269 9.25558C48.9591 8.86262 48.7136 8.50769 48.405 8.21218C48.0964 7.91667 47.7311 7.68669 47.3313 7.53611C46.9314 7.38553 46.5052 7.31745 46.0784 7.33599L11.5384 8.84399C10.7236 8.87972 9.95407 9.22855 9.39019 9.81776C8.82632 10.407 8.51162 11.1911 8.51172 12.0067V46.2067C8.51158 46.6327 8.59747 47.0545 8.76423 47.4466C8.931 47.8387 9.17522 48.1931 9.48225 48.4885C9.78927 48.784 10.1528 49.0144 10.551 49.166C10.9492 49.3176 11.3739 49.3872 11.7997 49.3707L15.6184 49.2213",
    stroke: "#98BCDE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.3c76e935ceb852afd3e96060fcafd916.svg";
export { ForwardRef as ReactComponent };